import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './App.css';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import GallerySection from './components/GallerySection';
import GamesSection from './components/GamesSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import SurpriseModal from './components/SurpriseModal';
import FloatingElements from './components/FloatingElements';
import Navigation from './components/Navigation';

function App() {
  const [showSurprise, setShowSurprise] = useState(false);
  const [currentTheme, setCurrentTheme] = useState('rainbow');

  const handleSurpriseClick = () => {
    setShowSurprise(true);
  };

  const closeSurprise = () => {
    setShowSurprise(false);
  };

  const changeTheme = (newTheme: string) => {
    setCurrentTheme(newTheme);
    document.body.className = `theme-${newTheme}`;
  };

  return (
    <div className={`App theme-${currentTheme}`}>
      <Navigation />
      <FloatingElements />
      
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <HeroSection onSurpriseClick={handleSurpriseClick} />
        <AboutSection />
        <GallerySection />
        <GamesSection onThemeChange={changeTheme} />
        <ContactSection />
      </motion.main>
      
      <Footer />
      
      <AnimatePresence>
        {showSurprise && (
          <SurpriseModal onClose={closeSurprise} />
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;